import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import RequireAuth from '../RequireAuth';
import MemberShell from './MemberShell';
import FirstLoginConsentGate from '../consent/FirstLoginConsentGate';
import MemberErrorBoundary from '../MemberErrorBoundary';

/**
 * The gate sits INSIDE RequireAuth (it needs the signed-in uid) but OUTSIDE
 * MemberShell, so an ungated member never sees the app chrome or any record
 * behind it — not a nav rail, not a flash of Home.
 *
 * The error boundary sits INSIDE MemberShell so a broken page keeps the nav
 * rail on screen and the member can navigate away. Keying it on the pathname
 * clears a stale error when they do.
 */
export default function MemberProtectedLayout() {
  const location = useLocation();
  return (
    <RequireAuth>
      <FirstLoginConsentGate>
        <MemberShell>
          <MemberErrorBoundary key={location.pathname}>
            <Outlet />
          </MemberErrorBoundary>
        </MemberShell>
      </FirstLoginConsentGate>
    </RequireAuth>
  );
}
